var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-title",class:_vm.classNames,style:(_vm.mergeStyle)},[_c('span',{staticClass:"base-title__text"},[(_vm.$slots.default)?[_vm._t("default")]:[_vm._v(" "+_vm._s(_vm.title)+" ")]],2),_vm._t("link")],2)}
var staticRenderFns = []

export { render, staticRenderFns }